import { render, staticRenderFns } from "./audit-log-page.vue?vue&type=template&id=00b38648&"
import script from "./audit-log-page.vue?vue&type=script&lang=js&"
export * from "./audit-log-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports